<template>
    <div class="footer-simple" :style="style">
        <span>{{ copyright }}</span>
        <span class="icp" @click="goIcp" v-show="icp">{{ icp}}</span>
        <span @click="goPolice" v-show="websiteOnFile">
            <img class="police_logo" :src="police_logo" alt="">
            {{ websiteOnFile}}</span>
        <span 
            v-show="!footer.isHideSupport"
            @click="jumpCredamo"
            class="footer">{{$t('paas_system.system.technical_support_provided')}}</span>
    </div>
</template>

<style scoped>
.footer-simple{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #666666;
    font-size: 14px;
    color: #D7D7D7;
}
span:nth-child(1){
    margin-top: .25rem;
    margin-bottom: .11rem;
}
span:nth-child(2){
    margin-bottom: .11rem;
}
span:nth-child(3){
    margin-bottom: .11rem;
    cursor: pointer;
}
.police_logo{
    vertical-align: middle;
}
.icp{
    cursor: pointer;
}
.footer{
    margin-bottom: 20px;
    cursor: pointer;
}
</style>

<script>
import {commonParams} from '@/config/common.js'
export default {
    props: {
        footer: Object
    },
    data(){
        return{
            police_logo:`${commonParams.CDN_IMG_PAAS}/police.png`
        }
    },
    computed: {
        style(){
            return `background-color:${this.footer.footerBgColor};
            color:${this.footer.footerFontColor};`
        },
        copyright(){
            return this.$getConfigText(this.footer.copyright) ||'北京易数模法科技有限公司 版权所有'
        },
        icp(){
            return this.footer.icp === undefined ?
            '© 京ICP备18010967号' : this.$getConfigText(this.footer.icp)
        },
        websiteOnFile(){
            return this.footer.websiteOnFile === undefined ?
            '京公网安备 11010502048986号' : this.$getConfigText(this.footer.websiteOnFile)
        }
    },
    methods:{
        jumpCredamo(){
            window.location.href = `https://www.credamo.com`
        },
        goIcp(){
            window.open('https://beian.miit.gov.cn')
        },
        goPolice(){
            window.open('http://www.beian.gov.cn/portal/recordQuery?token=f454ec65-95e2-4182-88f3-158921bd413f')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/footer/simple.vue